import "./Header.css";

import { useImperativeHandle, useState, forwardRef } from "react";

import { Link } from "react-router-dom";

import Hamburger from "../Hamburger/Hamburger";

import logo from "../../Media/logo.png";

const Header = forwardRef((props, ref) => {
	const [hamburgerOpen, setHamburgerOpen] = useState(false);

	const toggleHamburgerOpen = () => {
		setHamburgerOpen(!hamburgerOpen);
	}

	const backDropHandler = () => {
		setHamburgerOpen(false);
	}

	useImperativeHandle(ref, () => ({
		closeHamburger() {
			setHamburgerOpen(false);
		}
	}));

	return (
		<div className="headerContainer">
			<div className="header">
				<div className="logoContainer">
					<Link className="logoLink" to={"/"}>
						<img className="logo" src={logo} />
					</Link>
				</div>

				<navbar className="navLinkContainer">
					<Link className="navLink" to={"/team"}>DIE IMKER</Link>
					<Link className="navLink" to={"/photos"}>FOTOS</Link>
					<Link className="navLink" to={"/products"}>PRODUKTE</Link>
					<Link className="navLink" to={"/contact"}>KONTAKT</Link>
				</navbar>

				<div className={`hamburgerContainer ${hamburgerOpen ? "open" : ""}`} onClick={toggleHamburgerOpen}>
					<Hamburger />
				</div>
			</div>

			<div
				className={`backDrop ${hamburgerOpen ? "open" : ""}`}
				onClick={backDropHandler}
			/>

			<navbar className={`sideDrawerNav ${hamburgerOpen ? "open" : ""}`} >
				<Link className="sideDrawerNavLink" to={"/team"}>DIE IMKER</Link>
				<Link className="sideDrawerNavLink" to={"/photos"}>FOTOS</Link>
				<Link className="sideDrawerNavLink" to={"/products"}>PRODUKTE</Link>
				<Link className="sideDrawerNavLink" to={"/contact"}>KONTAKT</Link>´
			</navbar>
		</div>
	);
});

export default Header;